import { connect } from "react-redux";

import Component from "./Component";
import { getGroups } from "domain/Groups/selectors";
import { toArray } from "lib/converters";

const MapStateToProps = (state) => {
    return {
        groups: toArray(getGroups(state)),
    };
};

export default connect(MapStateToProps)(Component);
